import type { PortfolioActivityReferenceResource } from "api/generated";
import type { Reference } from "portfolio/types/reference.types";

export const referenceFromDto = (
  resource: PortfolioActivityReferenceResource,
): Reference => ({
  id: resource.id,
  name: resource.name,
  relation: resource.relation,
  email: resource.email,
  answer: resource.answer,
  date: resource.date ? new Date(resource.date) : null,
});
